import { render, staticRenderFns } from "./PromotionMemberGroupReview.vue?vue&type=template&id=18da200a&"
import script from "./PromotionMemberGroupReview.vue?vue&type=script&lang=js&"
export * from "./PromotionMemberGroupReview.vue?vue&type=script&lang=js&"
import style0 from "./PromotionMemberGroupReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionMemberGroupReview.vue"
export default component.exports